export default __webpack_public_path__ + "static/media/trampapo_01-02.2cca8d01.jpg";